module.exports = __webpack_public_path__ + "img/specialite_medecine.0ba36b48.png";